// extracted by mini-css-extract-plugin
export default {"titleWrapper":"SectionTitle_titleWrapper__uBACA","titleIcon":"SectionTitle_titleIcon__uHacA","title":"SectionTitle_title__Ii4cw"};